<!--
// app/components/Shared/slider-matches/CurrentSeasonSliderMatchesTeam.vue
-->
<script setup lang="ts">
import type { Season } from "~/src/season-cluster/domain/models/01.Season";
import type { MatchCenterData } from "~/src/match/domain/models/Match";
import SliderMatches from "~/app/components/Shared/slider-matches/SliderMatches.vue";
import SliderWrapper from "~/app/components/Shared/SliderWrapper.vue";
import { useSeasons } from "~/app/composables/season/seasons";
import { useTeams } from "~/app/composables/teams";
import ButtonEcalSync from "~/app/components/Shared/ButtonEcalSync.vue";
import regionUiService from "~/src/region/infrastructure/ui-services/regionUiService";

type Props = {
  teamId: number;
  teamSeasons: Season[] | undefined;
  regionReference?: number;
  withAddToCalendarInSection?: boolean;
};

const props = defineProps<Props>();

const { getSeasonTeams, useFetchParamsSeasonMatchCenterData } = useSeasons();
const { teamArrToObjById, findTeamCurrentOrRecentSeason } = useTeams();
const { findRegionInfoByRegionId } = regionUiService();
const { locale } = useI18n();

const currentOrRecentTeamSeason = props.teamSeasons
  ? findTeamCurrentOrRecentSeason(props.teamSeasons)
  : undefined;
const currentOrRecentTeamSeasonTeams = currentOrRecentTeamSeason
  ? await getSeasonTeams(currentOrRecentTeamSeason.id)
  : [];

const teamsObj = await teamArrToObjById(currentOrRecentTeamSeasonTeams, currentOrRecentTeamSeason?.id);

const { path, opts } = useFetchParamsSeasonMatchCenterData(
  currentOrRecentTeamSeason?.id,
  locale.value,
  props.teamId
);
const { data, error } = await useFetch(path, opts);

if (error.value) {
  console.error(error.value);
}

const seasonTurns: MatchCenterData[] = currentOrRecentTeamSeason ? data.value : undefined;

const regionEcalWidgetId = findRegionInfoByRegionId(props.regionReference, "ecalWidgetId");
</script>

<template>
  <div class="px-4 md:px-6 pb-8" v-if="seasonTurns.length">
    <p class="kql-page-section-title flex items-baseline justify-between">
      {{ $t("teams.nextMatches.title") }}
      <button-ecal-sync
        v-if="withAddToCalendarInSection"
        in-title
        :widget-id="regionEcalWidgetId"
      ></button-ecal-sync>
    </p>
    <hr />
  </div>
  <slider-wrapper
    v-if="seasonTurns.length"
    :scroll-distance="170"
    auto-scroll-selector=".card-match.live-match, .card-match[data-last-played]"
    scrollable-selector=".matches-slider-wrapper"
  >
    <slider-matches
      :phase-turns="seasonTurns"
      :teams="teamsObj"
      :region-reference="regionReference"
    ></slider-matches>
  </slider-wrapper>
</template>

<style scoped></style>
